import React from 'react';

import '../../pages/login/Style.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { getImage } from '../../services/getAssets';

import LoginArea from '../../components/login/login-area/LoginArea';
import PrimeiroAcesso from '../../components/login/primeiro-acesso/PrimeiroAcesso';
import { useAuth } from '../../hooks/useAuth';

export default function () {
  const { isFirstAccess } = useAuth();

  return (
    <div className="pagina-login">
      <div className="pagina-login-container">
        <div className="col-md-6 login-area">
          <div className="col-xl-12 header">
            <img src={getImage('logo.png')} alt="" />
          </div>
          <div className="col-xl-12 body">
            {!isFirstAccess ? <LoginArea /> : <PrimeiroAcesso />}
          </div>
        </div>
        <div className="col-md-6 photo">
          <div className="photo-after">
            <p>Sejam bem-vindos</p>
            <p>
              <strong>
                {process.env.REACT_APP_COMPANY_SLOGAN
                  ? process.env.REACT_APP_COMPANY_SLOGAN
                  : 'ao banco do empreendedor.'}
              </strong>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer limit={2} />
    </div>
  );
}